/**
 * Selector helpers for workflow-centric UI (processing busy, etc.).
 */

export const isActiveWorkflowProcessingBusyState = (state) => {
  const wf = state?.workflowSessions;
  const id = wf?.activeSessionId;
  if (!id) return false;
  const session = wf?.sessions?.[id];
  const st = session?.state;
  if (st?.stepsCompleted) return false;

  const inQueue = wf?.processingQueue?.includes(id);
  const current = wf?.currentlyProcessingSessionId === id;
  return !!(st?.isProcessing || inQueue || current);
};
